export const priority = "PRIORITY";
export const pickupNumber = "PICKUPNUMBER";
export const customer = "CUSTOMER";
export const site = "SITE";
export const country = "COUNTRY";
export const collectionDate = "COLLECTIONDATE";
export const receiveT1a = "RECEIVET1A";
export const registrations = "Registrations";
export const upcycleRecycle = "UpcycleRecycle";
export const co2 = "Co2";

export const koReportingSearchOption = [
    { key: "8", text: "Pickup No", value: "PickupNo" },
    { key: "9", text: "Reference", value: "Reference" },
    { key: "10", text: "Collection Date", value: "CollectionDate" },
    { key: "11", text: "Report Date", value: "ReportDate" },
    { key: "12", text: "City", value: "City" },
    { key: "13", text: "Country", value: "Country" },

]
export const koReportOption = [
    { key: "1", text: "Serialnumbers", value: registrations },
    { key: "2", text: "Upcycle / Recycle", value: upcycleRecycle },
    { key: "3", text: "Co2", value: co2 },

]
